import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const getDealsToolSignature = createToolSignature({
    name: 'getHubspotDeals',
    description: 'Gets deals from Hubspot for the users organization',
    inputSchema: z.object({}),
    outputSchema: z.object({
        deals: z.array(z.any()),
    }),
    toolCallUi: (args) => {
        return 'Getting deals from Hubspot.';
    },
});
